import request from "../request";

export const refund = ({orderId, eventId, agree_refund = false}) => {
	return request({
		url: "/refund",
		data: {
			order_id: orderId,
			event_id: eventId,
			agree_refund: agree_refund,
		},
	});
};
